import React from 'react';
import { Accordion, List } from 'antd-mobile';
import '../../index.css';
import intl from 'react-intl-universal';


class Page1 extends React.Component {
    onChange = (key) => {
        console.log(key);
    }
    render() {
        return (
            // <div style={{ marginTop: 10, marginBottom: 10 }}>
            //     <Accordion defaultActiveKey="0" className="my-accordion" onChange={this.onChange} defaultActiveKey>
            //         <Accordion.Panel header="无法配网，热点正确" className="pad">
            //            <p>{intl.get('a1')}</p>
            //         </Accordion.Panel>
            //     </Accordion>
                
            // </div>
            <div className="body_pad">
                {intl.getHTML('a1')}
            </div>
        );
    }
}
export default Page1;
